import React from "react";
import Typography from "@material-ui/core/Typography";
const Invoice = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Invoice
      </Typography>
      <Typography paragraph variant="h5">
        Manage A/R and A/P invoice to be more professional
      </Typography>
      <Typography paragraph variant="body1">
        Invoice is one of the features under the Finance module to perform
        billing transactions particularly to handle billing processes from
        customers for accounts receivable flow and from vendors for accounts
        payable flow. It contains any information regarding the customer or
        vendor address & contact, currency & exchange rate used for the
        transaction, applied terms & conditions, and the invoice items detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Invoice list.
        There are 2 types of Invoice list: Accounts Receivable Invoice list and
        Accounts Payable Invoice list. It is displayed like a table that
        contains download functions, sort, filter, and global search on the
        header area, and contains data navigation and refresh function on the
        footer area. The data column that appears in this table list are listed
        below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Receivable Invoice</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/R Invoice ID</b>
        <br />
        Indicates the ID of the Accounts Receivable Invoice.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Name</b>
        <br />
        Indicates the name of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Invoice Date</b>
        <br />
        Indicates the invoice date of the Accounts Receivable Invoice.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Goods Issue Status</b>
        <br />
        Indicates the goods issue status of the Sales Order related to Accounts
        Receivable Invoice. There are 3 statuses: Unissued, Partially Issued,
        and Fully Issued.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Payment Status</b>
        <br />
        Indicates the payment status of the Accounts Receivable Invoice. There
        are 3 statuses: Unpaid, Partially Paid, and Fully Paid.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Billing Amount</b>
        <br />
        Indicates the billing amount of the Accounts Receivable Invoice.
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Payable Invoice</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/P Invoice ID</b>
        <br />
        Indicates the ID of the Accounts Payable Invoice.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Name</b>
        <br />
        Indicates the name of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Invoice Date</b>
        <br />
        Indicates the invoice date of the Accounts Payable Invoice.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Goods Receive Status</b>
        <br />
        Indicates the goods receive status of the Purchase Order related to
        Accounts Payable Invoice. There are 3 statuses: Unreceived, Partially
        Received, and Fully Received.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Payment Status</b>
        <br />
        Indicates the payment status of the Accounts Payable Invoice. There are
        3 statuses: Unpaid, Partially Paid, and Fully Paid.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Grand Total</b>
        <br />
        Indicates the grand total of the Accounts Payable Invoice.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Accounts Receivable Invoice and Accounts Payable Invoice
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Receivable Invoice</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Account Receivable Invoice</b>
        <br />
        This button only appears if the Payment status is 'Unpaid', the Invoice
        is not Direct Sales Invoice or Down Payment Invoice, and the approval
        indicator is not 'Document Waiting For Approval'. It is used to edit the
        Accounts Receivable Invoice data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Account Receivable Invoice Detail</b>
        <br />
        This button is used to navigate to the Accounts Receivable Invoice
        detail which contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Accounts Receivable
            Invoice data.
          </li>
          <li>
            <b>A/R Payments</b> : This tab is to display any A/R Payments
            related to the Accounts Receivable Invoice.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Accounts Receivable Invoice.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Accounts Receivable Invoice.
          </li>
          <li>
            <b>PrintOut</b> : This tab is to display any PrintOut related to the
            Accounts Receivable Invoice.
          </li>
        </ul>
        When opening the Accounts Receivable Invoice detail, there will be 1
        button appearing on the top section. The button is 'Edit A/R Invoice'
        which is used to edit the Accounts Receivable Invoice data. The button
        only appears when the Payment status is 'Unpaid', the Invoice is not
        Direct Sales Invoice or Down Payment Invoice, and the approval indicator
        is not 'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Account Receivable Invoice</b>
        <br />
        This button only appears if the Payment status is 'Unpaid', the Invoice
        is not Direct Sales Invoice or Down Payment Invoice, and the approval
        indicator is not 'Document Waiting For Approval'. It is used to delete
        the Accounts Receivable Invoice data. The Accounts Receivable Invoice
        data is undeletable once it has relations with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Accounts Receivable Invoice document could have an approval flow if
        it is configured. The approval indicator appears as an icon after the
        document ID. There are 4 approval indicators: Document No Need Approval,
        Document Waiting For Approval, Document Approved, and Document Rejected.
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Payable Invoice</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Account Payable Invoice</b>
        <br />
        This button only appears if the Payment status is 'Unpaid' and the
        approval indicator is not 'Document Waiting For Approval'. It is used to
        edit the Accounts Payable Invoice data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Account Payable Invoice Detail</b>
        <br />
        This button is used to navigate to the Accounts Payable Invoice detail
        which contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Accounts Payable
            Invoice data.
          </li>
          <li>
            <b>A/P Payments</b> : This tab is to display any A/P Payments
            related to the Accounts Payable Invoice.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Accounts Payable Invoice.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Accounts Payable Invoice.
          </li>
        </ul>
        When opening the Accounts Payable Invoice detail, there will be 1 button
        appearing on the top section. The button is 'Edit A/P Invoice' which is
        used to edit the Accounts Payable Invoice data. The button only appears
        when the Payment status is 'Unpaid' and the approval indicator is not
        'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Account Payable Invoice</b>
        <br />
        This button only appears if the Payment status is 'Unpaid' and the
        approval indicator is not 'Document Waiting For Approval'. It is used to
        delete the Accounts Payable Invoice data. The Accounts Payable Invoice
        data is undeletable once it has relations with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Accounts Payable Invoice document could have an approval flow if it
        is configured. The approval indicator appears as an icon after the
        document ID. There are 4 approval indicators: Document No Need Approval,
        Document Waiting For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default Invoice;
